module.exports = __webpack_public_path__ + "static/img/shanzha.d197aacb.png";